<template>
  <layoutContainer>
    <div class="social-security-page">
      <!-- 主要内容区域 -->
      <div class="main-content">
        <!-- 视频播放区域 -->
        <!-- 视频播放器 -->
        <video
          id="social-security-player"
          width="1200"
          height="675"
          preload="auto"
          playsinline
          webkit-playsinline
          controls
        ></video>

        <!-- 未上传提示 -->
        <div v-show="!hasVideo" class="no-video-tip">
          <i class="el-icon-video-camera"></i>
          <p>{{ videoName || '还未上传社保视频文件' }}</p>
        </div>

        <!-- 视频标题 -->
        <!-- <div v-if="videoName && hasVideo" class="video-title">
              <h2>{{ videoName }}</h2>
            </div> -->
        <div v-if="videoName && hasVideo" class="video-title">
          <h1>{{ videoName }}</h1>
        </div>

        <!-- 视频上传区域 -->
        <div class="upload-section" v-if="type !== 'socialExample'">
          <div class="upload-container">
            <!-- 文件选择 -->
            <div class="file-select">
              <el-input
                v-model="selectedFileName"
                placeholder="选择社保记录视频文件"
                readonly
                class="file-input"
                @click="triggerFileSelect"
              >
                <el-button slot="append" :disabled="uploading" @click="triggerFileSelect">选择文件</el-button>
              </el-input>
              <input
                ref="fileInput"
                type="file"
                :accept="allowedFormats"
                @change="handleFileSelect"
                style="display: none"
              />
            </div>

            <!-- 上传按钮和进度 -->
            <div class="upload-actions">
              <el-button
                type="primary"
                :loading="uploading"
                @click="handleUpload"
                :disabled="!selectedFile"
                class="upload-btn"
              >
                {{ hasVideo ? '重新上传' : '上传' }}
              </el-button>

              <!-- 上传进度 -->
              <div v-if="uploading" class="upload-progress">
                <span>上传中 {{ uploadProgress }}%</span>
                <el-progress :percentage="uploadProgress" :show-text="false" class="progress-bar"></el-progress>
              </div>
            </div>
          </div>
        </div>
        <div class="tips" v-if="type !== 'socialExample'">(本页仅您和运营人员可见)</div>
      </div>

      <!-- 上传完成提示 -->
      <el-dialog
        :visible.sync="showUploadSuccess"
        title="上传完成"
        width="300px"
        :show-close="false"
        :close-on-click-modal="false"
        :close-on-press-escape="false"
      >
        <div class="upload-success-content">
          <i class="el-icon-success success-icon"></i>
          <p>视频上传完成！</p>
        </div>
        <div slot="footer" class="dialog-footer">
          <el-button type="primary" @click="closeUploadSuccess">确定</el-button>
        </div>
      </el-dialog>
    </div>
  </layoutContainer>
</template>

<script>
import {mapState} from 'vuex'
import {getSocialSecurityVideo, getDefaultSocialSecurity} from '@/api/socialSecurity'
import {videoRecords} from '@/api/consultingRoom'
import videoPublishManager from './publishVideo.js'
export default {
  name: 'SocialSecurityPage',
  data() {
    return {
      searchKeyword: '',
      selectedFile: null,
      selectedFileName: '',
      uploading: false,
      uploadProgress: 0,
      showUploadSuccess: false,
      hasVideo: false,
      videoInfo: {
        appId: '',
        psign: '',
        existsUploadVideo: false,
        socialSecurityCloudFileId: ''
      },
      player: null,
      consultantId: null,
      // 视频上传相关
      videoFile: null,
      applyId: null,
      isDel: false,
      // 允许的视频格式
      allowedFormats: '.mp4,.ts,.flv,.wmv,.asf,.rm,.rmvb,.mpg,.mpeg,.3gp,.mov,.webm,.mkv,.avi',
      type: '',
      // 通用视频播放参数
      cloudVideoId: null,
      videoName: ''
    }
  },
  computed: {
    ...mapState(['UserInfo']),

    // 是否为当前用户或运营人员
    isAuthorized() {
      return this.UserInfo?.role === 'operator' || this.UserInfo?.role === 'admin' || this.isCurrentUser
    },

    // 是否为当前用户
    isCurrentUser() {
      // 判断是否为当前用户：比较路由参数中的 consultant_id 和当前登录用户的 ID
      if (!this.consultantId || !this.UserInfo || !this.UserInfo.id) {
        return false
      }
      return Number(this.consultantId) === Number(this.UserInfo.id)
    }
  },
  created() {
    // 从URL参数获取 consultant_id（社保记录页使用此参数）
    this.consultantId = this.$route.query.consultant_id || this.$route.query.consultantId || ''
    this.type = this.$route.query.type || ''

    // 如果没有 consultant_id，跳转到首页
    if (!this.consultantId) {
      this.$message.error('缺少必要参数')
      this.$router.push('/')
      return
    }

    // 加载视频信息（会进行身份校验）
    this.loadVideoInfo()
  },
  mounted() {
    this.initVideoPlayer()
  },
  beforeDestroy() {
    if (this.player) {
      this.player.dispose()
    }
  },
  methods: {
    // 权限检查
    checkPermission() {
      if (!this.isAuthorized) {
        this.$message.error('您没有权限访问此页面')
        this.$router.push('/')
        return
      }
    },

    // 加载视频信息
    async loadVideoInfo() {
      try {
        // 如果是社保记录示例，从后端获取配置信息
        if (this.type === 'socialExample') {
          const response = await getDefaultSocialSecurity()
          if (response.code === 200 && response.data) {
            this.videoInfo = {
              socialSecurityCloudFileId: response.data.socialSecurityCloudFileId,
              appId: response.data.appId,
              psign: response.data.psign
            }
            this.videoName = response.data.fileName || '社保记录示例'
            this.hasVideo = true
            this.$nextTick(() => {
              this.initVideoPlayer()
            })
          } else {
            this.$message.error('获取示例视频配置失败')
          }
          return
        }

        // 如果是预约视频播放
        if (this.$route.query.appointmentId) {
          const response = await videoRecords(this.$route.query.appointmentId)
          if (response.code === 200 && response.data.length !== 0) {
            this.videoInfo = {
              ...response.data.filter(item => item.cloudFileId === this.$route.query.cloudFileId)[0],
              socialSecurityCloudFileId: this.$route.query.cloudFileId
            }
            this.hasVideo = true
            if (this.hasVideo) {
              this.$nextTick(() => {
                this.initVideoPlayer()
              })
            }
          }
          return
        }

        // 社保记录页：通过 consultant_id 调用后端接口获取播放参数
        // 后端会进行身份校验，只有本人和运营人员可以访问
        if (this.consultantId) {
          const response = await getSocialSecurityVideo(this.consultantId)

          // 身份校验不通过，跳转到首页
          if (response.code === 200105) {
            this.$message.error('您没有权限访问此页面')
            this.$router.push('/')
            return
          }

          // 获取成功，设置视频信息
          if (response.code === 200 && response.data) {
            this.videoInfo = response.data
            this.hasVideo = response.data.existsUploadVideo
            this.videoName = response.data.fileName || '社保记录'

            if (this.hasVideo) {
              this.$nextTick(() => {
                this.initVideoPlayer()
              })
            }
          } else {
            this.$message.error(response.msg || '获取视频信息失败')
          }
        }
      } catch (error) {
        console.error('加载视频信息失败:', error)
        this.$message.error('加载视频信息失败，请重试')
        // 出错时也跳转到首页
        this.$router.push('/')
      }
    },

    // 初始化视频播放器
    initVideoPlayer() {
      if (!this.hasVideo || !this.videoInfo.socialSecurityCloudFileId) return

      // 使用腾讯云播放器
      if (window.TCPlayer) {
        console.log(
          {
            fileID: this.videoInfo.socialSecurityCloudFileId,
            appID: this.videoInfo.appId,
            psign: this.videoInfo.psign,
            width: 1200,
            height: 675,
            autoplay: false,
            plugins: {
              ProgressMarker: true,
              ContextMenu: {
                statistic: true,
                levelSwitch: {
                  open: true,
                  switchingText: 'Start switching',
                  switchedText: 'Switch success',
                  switchErrorText: 'Switch fail'
                }
              }
            }
          },
          '99999'
        )
        console.log('this.videoInfo = ', this.videoInfo)
        this.player = window.TCPlayer('social-security-player', {
          fileID: this.videoInfo.socialSecurityCloudFileId,
          appID: this.videoInfo.appId,
          psign: this.videoInfo.psign,
          autoplay: false,
          plugins: {
            ProgressMarker: true,
            ContextMenu: {
              statistic: true,
              levelSwitch: {
                open: true,
                switchingText: 'Start switching',
                switchedText: 'Switch success',
                switchErrorText: 'Switch fail'
              }
            }
          }
        })
      }
    },

    // 触发文件选择
    triggerFileSelect() {
      this.$refs.fileInput.click()
    },

    // 处理文件选择
    handleFileSelect(event) {
      const files = event.target.files
      if (!files.length) return

      const file = files[0]

      // 检查文件格式
      const fileName = file.name.toLowerCase()
      const isValidFormat = this.allowedFormats.split(',').some(format => fileName.endsWith(format.toLowerCase()))

      if (!isValidFormat) {
        this.$message.error(
          '请选择支持的视频格式：MP4、TS、FLV、WMV、ASF、RM、RMVB、MPG、MPEG、3GP、MOV、WEBM、MKV、AVI'
        )
        return
      }

      // 检查文件大小（1GB = 1024MB = 1024 * 1024 * 1024 bytes）
      const maxSize = 1024 * 1024 * 1024 // 1GB
      if (file.size > maxSize) {
        this.$message.error('视频文件大小不能超过1GB')
        return
      }

      // 设置文件信息（参考publishDialog的实现）
      this.videoFile = files
      this.selectedFile = file
      this.selectedFileName = file.name
      console.log('选择的视频文件:', this.videoFile)
    },

    // 处理上传
    async handleUpload() {
      if (!this.selectedFile || !this.videoFile) {
        this.$message.warning('请先选择视频文件')
        return
      }

      // 检查用户是否已开通接受预约
      //   try {
      //     const permissionResponse = await checkAppointmentPermission(this.consultantId)
      //     if (permissionResponse.code !== 200 || !permissionResponse.data) {
      //       this.$message.error('您尚未开通接受预约功能，无法上传社保视频')
      //       return
      //     }
      //   } catch (error) {
      //     this.$message.error('权限检查失败，请重试')
      //     return
      //   }

      // 如果是重新上传，先删除旧文件
      //   if (this.hasVideo) {
      //     try {
      //       await deleteSocialSecurityVideo(this.consultantId)
      //     } catch (error) {
      //       console.error('删除旧文件失败:', error)
      //     }
      //   }

      // 开始上传
      this.uploading = true
      this.uploadProgress = 0
      this.isDel = false

      // 使用专门的社保视频上传管理器
      videoPublishManager.initTvVod(
        this.videoFile[0],
        this.percentCallBack,
        this.doneCallBack,
        this.errCallBack,
        this.consultantId
      )
    },

    // 上传进度回调（参考publishDialog的实现）
    percentCallBack(info) {
      this.uploadProgress = Math.round(info * 100)
      console.log('上传进度:', this.uploadProgress + '%')
    },

    // 上传完成回调（参考publishDialog的实现）
    doneCallBack(info) {
      console.log('上传完成:', info)
      this.uploading = false
      this.uploadProgress = 0

      if (this.isDel) {
        this.isDel = false
        return
      }

      this.showUploadSuccess = true
      this.selectedFile = null
      this.selectedFileName = ''
      this.videoFile = null

      // 重新加载视频信息
      this.loadVideoInfo()
    },

    // 上传错误回调（参考publishDialog的实现）
    errCallBack(info) {
      console.error('上传失败:', info)
      this.uploading = false
      this.uploadProgress = 0
      this.$message.error('视频上传失败，请重试')
    },

    // 处理搜索
    handleSearch() {
      if (this.searchKeyword.trim()) {
        // 实现搜索逻辑
        console.log('搜索关键词:', this.searchKeyword)
      }
    },
    closeUploadSuccess() {
      window.location.reload()
    }
  }
}
</script>

<style lang="scss" scoped>
.social-security-page {
  min-height: 100vh;
  background-color: #f5f5f5;

  .page-header {
    background: #fff;
    padding: 20px 0;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);

    .header-content {
      max-width: 1200px;
      margin: 0 auto;
      display: flex;
      align-items: center;
      justify-content: space-between;
      padding: 0 20px;

      .search-section {
        flex: 1;
        max-width: 500px;

        .search-input {
          .el-input__inner {
            border-radius: 20px;
            border: 1px solid #ddd;
          }
        }
      }

      .action-section {
        .publish-btn {
          background: #ff6b35;
          border-color: #ff6b35;
          border-radius: 20px;
          padding: 10px 20px;

          &:hover {
            background: #ff5722;
            border-color: #ff5722;
          }
        }
      }
    }
  }

  .main-content {
    max-width: 1200px;
    margin: 20px auto;
    padding: 0 20px;

    .video-section {
      background: #fff;
      border-radius: 8px;
      padding: 20px;
      margin-bottom: 20px;
      box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);

      .video-container {
        position: relative;
        width: 100%;
        height: 675px;
        background: #000;
        border-radius: 8px;
        overflow: hidden;

        video {
          width: 100%;
          height: 100%;
          object-fit: contain;
        }

        .no-video-tip {
          position: absolute;
          top: 50%;
          left: 50%;
          transform: translate(-50%, -50%);
          color: #999;
          display: flex;
          flex-direction: column;
          align-items: center;
          gap: 8px;

          i {
            font-size: 48px;
            margin-bottom: 10px;
          }

          p {
            margin: 0;
            font-size: 16px;
          }
        }
      }
    }

    .video-title {
      h1 {
        text-align: center;
        margin: 0;
        color: #000;
        font-size: 18px;
        font-weight: 500;
        font-size: 30px;
      }
      margin: 30px 0;
    }
    .tips {
      text-align: center;
      margin-top: 20px;
      color: #999;
      font-size: 16px;
    }
    .upload-section {
      background: #fff;
      border-radius: 8px;
      padding: 20px;
      box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);

      .upload-container {
        display: flex;
        align-items: center;
        gap: 20px;

        .file-select {
          flex: 1;

          .file-input {
            .el-input__inner {
              cursor: pointer;
            }
          }
        }

        .upload-actions {
          display: flex;
          align-items: center;
          gap: 15px;

          .upload-btn {
            background: #ff6b35;
            border-color: #ff6b35;
            padding: 10px 20px;

            &:hover {
              background: #ff5722;
              border-color: #ff5722;
            }

            &:disabled {
              background: #ccc;
              border-color: #ccc;
              cursor: not-allowed;
            }
          }

          .upload-progress {
            display: flex;
            align-items: center;
            gap: 10px;
            min-width: 150px;

            span {
              font-size: 14px;
              color: #666;
              white-space: nowrap;
            }

            .progress-bar {
              flex: 1;
              min-width: 100px;
            }
          }
        }
      }
    }
  }
}

.upload-success-content {
  text-align: center;
  padding: 20px 0;

  .success-icon {
    font-size: 48px;
    color: #67c23a;
    margin-bottom: 15px;
  }

  p {
    margin: 0;
    font-size: 16px;
    color: #333;
  }
}

.dialog-footer {
  text-align: center;
}

// 响应式设计
@media (max-width: 768px) {
  .social-security-page {
    .main-content {
      padding: 0 10px;

      .video-section .video-container {
        height: 400px;
      }

      .upload-section .upload-container {
        flex-direction: column;
        align-items: stretch;

        .upload-actions {
          justify-content: center;
        }
      }
    }
  }
}
</style>
